import { formatCurrency } from '@/lib/utils'

interface MovimientosTableFooterProps {
  totalDebe: number
  totalHaber: number
  saldo: number
  /** Number of columns before the amount column(s) (depends on visible columns) */
  leadingColSpan: number
  showSaldo?: boolean
  debeHaberSeparado?: boolean
}

export function MovimientosTableFooter({
  totalDebe,
  totalHaber,
  saldo,
  leadingColSpan,
  showSaldo = true,
  debeHaberSeparado = false,
}: MovimientosTableFooterProps) {
  return (
    <tr>
      <td colSpan={leadingColSpan} className="px-4 py-2 font-bold text-sm">
        Totales
      </td>
      {debeHaberSeparado ? (
        <>
          <td className="px-4 py-2 text-right font-bold tabular-nums text-red-600">
            {formatCurrency(totalDebe)}
          </td>
          <td className="px-4 py-2 text-right font-bold tabular-nums text-green-600">
            {formatCurrency(totalHaber)}
          </td>
        </>
      ) : (
        <td className="px-4 py-2 text-right">
          <div className="flex flex-col items-end">
            <span className="font-bold tabular-nums text-red-600">
              {formatCurrency(totalDebe)}
            </span>
            <span className="font-bold tabular-nums text-green-600 text-xs">
              -{formatCurrency(totalHaber)}
            </span>
          </div>
        </td>
      )}
      {showSaldo && (
        <td className={`px-4 py-2 text-right font-bold tabular-nums ${saldo > 0 ? 'text-red-600' : 'text-green-600'}`}>
          {formatCurrency(Math.abs(saldo))}
          {saldo < 0 && <span className="text-xs ml-1">(a favor)</span>}
        </td>
      )}
      <td /> {/* acciones */}
    </tr>
  )
}
